import {observable, computed, action} from 'mobx';
import {api} from "../../services/index";

class Channels {
    @observable channels = [];

    constructor() {
    }

    @computed
    get numOfTwitchEmotes() {
        return this.channels.length;
    }

    @action
    fetchChannels() {
        api.getChannels(50)
        .then(res => {
            this.channels = res.data;
        })
        .catch(e => {
            console.log('e', e);
        })
    }

}

export default Channels;




// WEBPACK FOOTER //
// ./src/app/models/Channels.js